import { component } from "picoapp";
import { getQueryStringParameter } from "../../../scripts/lib/utils";
import Cookies from "js-cookie";
import { type Context, type Discount } from "../../state";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

export const loyalty = component<Context>((node, context) => {
  const {
    discount = "0",
    expires = "",
    name = "",
    productId = "",
  } = node.dataset;
  const cookieName = "_loyalty_discount";
  const loyaltyParameter = getQueryStringParameter("loyalty");
  const loyaltyCookie = Cookies.get(cookieName);

  const setLoyaltyCookie = () => {
    const loyaltyDiscount: Discount = {
      name,
      type: cookieName,
      value: parseInt(discount, 10),
      productId,
    };
    const expiresDate = new Date(expires);

    Cookies.set(cookieName, JSON.stringify(loyaltyDiscount), {
      expires: expiresDate,
    });
    setAppDiscount(context, loyaltyDiscount);
  };

  if (!loyaltyCookie && loyaltyParameter === name) {
    setLoyaltyCookie();
  } else if (loyaltyCookie) {
    const loyaltyDiscount: Discount = JSON.parse(loyaltyCookie);
    if (!name) {
      // Remove cookie if matching product is no longer assigned a loyalty discount
      if (productId === loyaltyDiscount.productId) {
        Cookies.remove(cookieName);
      }
    } else if (loyaltyDiscount.name !== name) {
      // Overwrite cookie if product is assigned a different loyalty discount
      setLoyaltyCookie();
    } else {
      // Set app state if name matches name in cookie
      setAppDiscount(context, loyaltyDiscount);
    }
  }
});

const setAppDiscount = (context: Context, discount: Discount) => {
  const state = context.getState();
  const discounts = [...(state.discounts ?? []), discount];
  context.hydrate({
    ...state,
    discounts,
  });
  TablescapeContext.emit(TablescapeEvent.UPDATE_DISCOUNTS, { discounts });
};
